import React, { useState } from "react";
import Wait from "../../Wait";
import LicenseWizard from "./LicenseWizard";
import Notification from "../Common/Notification";
import { useTypedSelector } from "../../redux/reducers/RootReducer";
import { getNotifications } from "../../redux/reducers/NotificationReducer";
import { ENotificationType } from "../../Model/ENotificationType";
import Loading from "../../Loading";
import { useDispatch } from "react-redux";
import { removeNotification } from "../../redux/actions/NotificationAction";

interface LicenseProps {
  isLoading?: boolean;
  isError?: boolean;
}

const License = (props: LicenseProps) => {
  const { isLoading, isError } = props;
  const dispatch = useDispatch();

  const notifications = useTypedSelector((state) => getNotifications(state));
  const notification = notifications[0];

  const [showLoading, setShowLoading] = useState(false);
  const [showErrorNotification, setShowErrorNotification] = useState(!!isError);

  const onNotificationClosed = () => {
    dispatch(removeNotification());
    setShowErrorNotification(false);
  };

  if (isLoading) return <Wait message="Loading Configuration" />;
  return (
    <div className="login-page">
      {showLoading && <Loading />}
      <LicenseWizard
        setShowLoading={setShowLoading}
        setShowErrorNotification={setShowErrorNotification}
      />
      <Notification
        type={notification?.type ?? ENotificationType.Info}
        active={notification != null && showErrorNotification}
        message={notification?.message}
        onClose={onNotificationClosed}
      />
    </div>
  );
};

export default License;
